import * as Logos from "@airhelp/logos";
import { Link } from "@chakra-ui/react";
import NextLink from "next/link";
import type { HeaderLogoProps } from "./types";

export const HeaderLogo = ({ language, headerLogo }: HeaderLogoProps) => {
  const Logo = Logos[headerLogo] || Logos.Airhelp;
  return (
    <Link as={NextLink} href={`/${language}/`} mr="auto">
      <Logo color="primary.900" minW={{ base: "94px", lg: "118px" }} minH={{ base: "32px", lg: "40px" }} />
    </Link>
  );
};
